import { Signboard } from './signboard'
import {DomainObject} from "../core/_base/crud/models/_domain.model";

export class BusinessName extends DomainObject {
    name: string
    signboards_ids: string[]  = []
    _signboards: Signboard[] = []
}
